import { gtag } from 'ga-gtag';

function trackEvent(eventName, params = {}) {
  try {
    gtag('event', eventName, params);
  } catch (e) {
    console.error('analyticsService.trackEvent failed:', e);
  }
}

export default { trackEvent };
